export const generateUniqId = (): string => {
    return String(Math.floor((Math.random() * 1000 ) * Date.now()))
};

export const generateUniqeReference = function (country: string): string {
    return country.toUpperCase() + '_' + generateUniqId();
};
